export default __webpack_public_path__ + "static/media/Cloak of the Crawling Chaos.938817b9.jpg";